import {
    ContentVariableGroupInterface,
    ContentVariableInterface
} from "~/cabinet/vue/interface/ContentVariableInterface";
import Dictionary from "~/ts/library/Dictionary";
import ObjectHelper from "~/ts/library/ObjectHelper";
import md5 from "~/ts/library/md5";

export default class ContentVariablesHelper {
    public static contentVariablesToGroups(variables: ContentVariableInterface[]): ContentVariableGroupInterface[] {
        let groupsDictionary: Dictionary<ContentVariableGroupInterface> = {};
        for (let variable of variables) {
            let groupDescr = variable.groupDescr ? variable.groupDescr : ["Поля"];
            let md5Hash = md5(JSON.stringify(groupDescr))
            if (!groupsDictionary[md5Hash]) {
                groupsDictionary[md5Hash] = {
                    id: md5Hash,
                    descr: groupDescr,
                    variables: []
                };
            }
            groupsDictionary[md5Hash].variables.push(variable);
        }
        return ObjectHelper.arrayFromDictionary(groupsDictionary);
    }

    public static getVariableNameFromPlaceholder(string: string) {
        return string.substring(1, string.length - 1);
    }
}